import React from "react";
import cx from "classnames";

import SequenceNumber from "../typography/SequenceNumber";

import styles from './NumberedListCard.module.scss';
import type {ResultListItemData} from "../../types";
import H3 from "../typography/H3";
import H4 from "../typography/H4";
import List1 from "../typography/List1";
import H6 from "../typography/H6";
import {typografText} from "../../utils/typograf";

type NumberedListCardProps = {
    desktopList?: string[];
    isError?: boolean;
    title: string;
    list: string[];
    subtitle: string;
    listResult: ResultListItemData[];
};

function NumberedListCard({desktopList, isError, title, subtitle, list, listResult}: NumberedListCardProps) {
    const renderOrderedList = (items: string[], className: string) => (
        <ul className={className}>
            {items.map((item, index) => (
                <li key={index} className={styles.orderedItem}>
                    <SequenceNumber className={styles.orderedContent}>
                        {typografText(`0${index + 1}`)}<span className={styles.numberDot}>.</span>
                    </SequenceNumber>
                    <List1 className={styles.orderedContent}>{item}</List1>
                </li>
            ))}
        </ul>
    );

    return (
        <div className={cx(styles.card, {
            [styles.cardError]: isError,
        })}>
            <H3 sx={{
                '@media screen and (min-width: 576px) and (max-width: 767px)': {
                    position: 'relative',
                    top: '3px',
                },
            }}>{title}{!isError && <span className={styles.successEmoji} aria-hidden="true"> 🏆</span>}</H3>
            {renderOrderedList(list, cx(styles.orderedList, {
                [styles.orderedListHasDesktop]: desktopList,
            }))}
            {desktopList && renderOrderedList(desktopList, cx(styles.orderedList, styles.orderedListDesktop))}
            <div className={styles.resultBlock}>
                <H4>{subtitle}</H4>
                <ul className={styles.resultList}>
                    {listResult.map(({emoji, text}, index) => (
                        <li key={index} className={styles.resultItem}>
                            <span className={styles.resultEmoji}>{emoji}</span>
                            <H6 sx={{
                                width: '100%',
                                // Keep all three success captions at two lines across breakpoints.
                                maxWidth: isError ? undefined : '9em',
                                '@media (min-width: 1200px) and (max-width: 1399px)': {
                                    maxWidth: '9em',
                                },
                                '@media screen and (min-width: 1200px)': {
                                    fontSize: '24px',
                                    lineHeight: 1.32,
                                },
                            }}>{text}</H6>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default NumberedListCard
